(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["primedeals-utility-dock"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.documentElement;
    const dock = document.querySelector('[data-pd-utility-dock]');
    const wishlistTrigger = document.querySelector('[data-pd-wishlist-open]');
    const wishlistCount = document.querySelector('[data-pd-wishlist-count]');
    const perksTrigger = document.querySelector('[data-pd-perks-open]');
    const perksBackdrop = document.querySelector('[data-pd-perks-close]');
    const perksReturn = document.querySelector('[data-pd-perks-return]');
    const perksReturnClose = document.querySelector('[data-pd-perks-return-close]');
    const perksCopy = document.querySelector('[data-pd-perks-copy]');
    const perksCode = document.querySelector('[data-pd-perks-code]');
    const perksCopyLabel = document.querySelector('[data-pd-perks-copy-label]');
    const perksReturnTitle = document.querySelector('[data-pd-perks-return-title]');
    const perksReturnText = document.querySelector('[data-pd-perks-return-text]');
    const perksHelp = document.querySelector('[data-pd-perks-help]');
    const promoStorageKey = 'pd-primo-perks-code-v1';
    let attracDialog;
    let attracStateObserver;
    let attracSuccessSeen = false;
    let perksOpenPending = false;
    let rememberedPromoCode = '';
    let wishlistObserver;

    if (
      !dock ||
      !wishlistTrigger ||
      !perksTrigger ||
      !perksBackdrop ||
      !perksReturn ||
      !perksReturnClose ||
      !perksCopy ||
      !perksCode ||
      !perksCopyLabel ||
      !perksReturnTitle ||
      !perksReturnText ||
      !perksHelp
    )
      return;

    const updateWishlistCount = (joyButton) => {
      const label = joyButton?.getAttribute('aria-label') || '';
      const match = label.match(/\((\d+)\s/);
      const count = match ? Number(match[1]) : 0;

      wishlistCount.textContent = String(count);
      wishlistCount.hidden = count < 1;
      wishlistTrigger.setAttribute('aria-label', label || wishlistTrigger.getAttribute('aria-label'));
    };

    const connectWishlist = () => {
      const host = document.querySelector("joy-wishlist-icon[variant='floating']");
      const joyButton = host?.shadowRoot?.querySelector('button');

      if (!joyButton) return false;

      host.setAttribute('aria-hidden', 'true');
      host.hidden = true;
      joyButton.setAttribute('aria-hidden', 'true');
      joyButton.hidden = true;
      joyButton.tabIndex = -1;
      updateWishlistCount(joyButton);
      wishlistObserver?.disconnect();
      wishlistObserver = new MutationObserver(() => updateWishlistCount(joyButton));
      wishlistObserver.observe(joyButton, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true,
      });
      dock.classList.add('is-wishlist-ready');
      return true;
    };

    const attracDialogIsReady = () =>
      Boolean(
        attracDialog?.isConnected &&
          attracDialog.querySelector('.aph_collapse_container') &&
          attracDialog.querySelector('.aph_collapse_info, .aph_collapse_thank')
      );

    const normalizePromoCode = (value) => {
      const normalized = String(value || '')
        .replace(/\s+/g, ' ')
        .trim();

      if (/^[a-z0-9_-]{4,32}$/i.test(normalized)) return normalized;

      return (
        normalized
          .match(/[a-z0-9][a-z0-9_-]{3,31}/gi)
          ?.sort((first, second) => second.length - first.length)[0] || ''
      );
    };

    const readRememberedPromoCode = () => {
      if (rememberedPromoCode) return rememberedPromoCode;

      try {
        const storedPromo = JSON.parse(window.localStorage.getItem(promoStorageKey) || 'null');
        rememberedPromoCode = normalizePromoCode(storedPromo?.code);
      } catch (error) {
        rememberedPromoCode = '';
      }

      return rememberedPromoCode;
    };

    const rememberPromoCode = (value) => {
      const code = normalizePromoCode(value);
      if (!code) return '';

      rememberedPromoCode = code;

      try {
        window.localStorage.setItem(promoStorageKey, JSON.stringify({ code }));
      } catch (error) {
        return code;
      }

      return code;
    };

    const getAttracPromoCode = () => {
      const coupon = attracDialog?.querySelector('.aph_collapse_coupon');
      return normalizePromoCode(coupon?.querySelector('input')?.value || coupon?.textContent);
    };

    const attracSignUpIsUsable = () =>
      Boolean(
        attracDialogIsReady() &&
          attracDialog.querySelector('.aph_collapse_email') &&
          attracDialog.querySelector('.aph_collapse_fields > .aph_collapse_btn')
      );

    const syncAttracState = () => {
      const thankYou = attracDialog?.querySelector('.aph_collapse_thank');
      const signUp = attracDialog?.querySelector('.aph_collapse_info');
      const promoCode = getAttracPromoCode();
      const thankYouVisible = Boolean(thankYou && window.getComputedStyle(thankYou).display !== 'none');
      const signUpHidden = Boolean(!signUp || window.getComputedStyle(signUp).display === 'none');
      const isSuccess = Boolean(thankYouVisible || (promoCode && signUpHidden));

      if (isSuccess) {
        attracSuccessSeen = true;
        rememberPromoCode(promoCode);
      }

      attracDialog?.classList.toggle('pd-perks-success', isSuccess || attracSuccessSeen);
      return { isSuccess, promoCode };
    };

    const prepareAttracDialog = () => {
      attracDialog = document.querySelector('.aph_collapse[role="dialog"]');

      if (!attracDialogIsReady()) {
        attracDialog = undefined;
        dock.classList.remove('is-perks-ready');
        perksTrigger.removeAttribute('aria-controls');
        return false;
      }

      if (!attracDialog.id) attracDialog.id = 'pd-perks-dialog';
      attracDialog.setAttribute('aria-hidden', root.classList.contains('pd-perks-open') ? 'false' : 'true');
      attracDialog.setAttribute('aria-modal', 'true');
      const firstNameField = attracDialog.querySelector('.aph_collapse_first_name');
      const emailField = attracDialog.querySelector('.aph_collapse_email');

      if (firstNameField) {
        firstNameField.required = true;
        firstNameField.autocomplete = 'given-name';
      }

      if (emailField) {
        emailField.type = 'email';
        emailField.required = true;
        emailField.autocomplete = 'email';
        emailField.inputMode = 'email';
      }

      perksTrigger.setAttribute('aria-controls', attracDialog.id);
      dock.classList.add('is-perks-ready');
      attracStateObserver?.disconnect();
      attracStateObserver = new MutationObserver(() => {
        const state = syncAttracState();
        if (state.isSuccess && !state.promoCode && root.classList.contains('pd-perks-open')) revealPerksRecovery();
      });
      attracStateObserver.observe(attracDialog, {
        attributes: true,
        attributeFilter: ['class', 'style'],
        childList: true,
        characterData: true,
        subtree: true,
      });
      syncAttracState();
      return true;
    };

    const syncAttracValidation = () => {
      const fields = attracDialog?.querySelectorAll('.aph_collapse_first_name, .aph_collapse_email') || [];

      fields.forEach((field) => {
        field.setAttribute('aria-invalid', field.validity.valid ? 'false' : 'true');
      });
    };

    const closePerks = (restoreFocus = true) => {
      perksOpenPending = false;
      dock.classList.remove('is-perks-loading');
      perksTrigger.removeAttribute('aria-busy');
      root.classList.remove('pd-perks-open');
      root.classList.remove('pd-perks-returning');
      perksTrigger.setAttribute('aria-expanded', 'false');
      attracDialog?.setAttribute('aria-hidden', 'true');
      perksReturn.setAttribute('aria-hidden', 'true');
      if (restoreFocus) perksTrigger.focus({ preventScroll: true });
    };

    const revealReturnPanel = (value = '') => {
      const code = normalizePromoCode(value);
      const hasCode = Boolean(code);

      perksOpenPending = false;
      dock.classList.remove('is-perks-loading');
      perksTrigger.removeAttribute('aria-busy');
      perksReturn.classList.toggle('is-recovery', !hasCode);
      perksReturnTitle.textContent = hasCode
        ? perksReturnTitle.dataset.codeTitle
        : perksReturnTitle.dataset.recoveryTitle;
      perksReturnText.textContent = hasCode ? perksReturnText.dataset.codeText : perksReturnText.dataset.recoveryText;
      perksCode.textContent = code;
      perksCopyLabel.textContent = perksCopy.getAttribute('aria-label');
      perksCopy.hidden = !hasCode;
      perksHelp.hidden = hasCode;
      attracDialog?.setAttribute('aria-hidden', 'true');
      perksReturn.setAttribute('aria-hidden', 'false');
      perksTrigger.setAttribute('aria-controls', perksReturn.id);
      perksTrigger.setAttribute('aria-expanded', 'true');
      root.classList.add('pd-perks-returning');
      root.classList.add('pd-perks-open');
      window.setTimeout(() => (hasCode ? perksCopy : perksHelp).focus({ preventScroll: true }), 220);
      return true;
    };

    const revealRememberedPromo = (value) => {
      const code = rememberPromoCode(value);
      return code ? revealReturnPanel(code) : false;
    };

    const revealPerksRecovery = () => revealReturnPanel();

    const revealPerks = () => {
      if (!attracSignUpIsUsable()) return false;

      perksOpenPending = false;
      dock.classList.remove('is-perks-loading');
      perksTrigger.removeAttribute('aria-busy');
      syncAttracState();
      root.classList.remove('pd-perks-returning');
      perksReturn.setAttribute('aria-hidden', 'true');
      root.classList.add('pd-perks-open');
      perksTrigger.setAttribute('aria-expanded', 'true');
      attracDialog?.setAttribute('aria-hidden', 'false');

      window.setTimeout(() => {
        if (!attracDialogIsReady()) {
          closePerks(false);
          return;
        }

        const emailField = attracDialog?.querySelector('.aph_collapse_email');
        emailField?.focus({ preventScroll: true });
      }, 240);

      return true;
    };

    const openPerksWhenReady = (attempt = 0) => {
      if (!perksOpenPending) return;

      const dialogPrepared = prepareAttracDialog();
      const restoredCode = readRememberedPromoCode();

      if (restoredCode && revealRememberedPromo(restoredCode)) return;
      if (attracSuccessSeen && revealPerksRecovery()) return;
      if (dialogPrepared && revealPerks()) return;

      if (attempt >= 20) {
        revealPerksRecovery();
        return;
      }

      window.setTimeout(() => openPerksWhenReady(attempt + 1), 150);
    };

    const openPerks = () => {
      const rememberedCode = readRememberedPromoCode();
      if (rememberedCode && revealRememberedPromo(rememberedCode)) return;

      const attracPrepared = prepareAttracDialog();
      const recoveredCode = readRememberedPromoCode();

      if (recoveredCode && revealRememberedPromo(recoveredCode)) return;
      if (attracSuccessSeen && revealPerksRecovery()) return;
      if (attracPrepared && revealPerks()) return;

      closePerks(false);
      perksOpenPending = true;
      dock.classList.add('is-perks-loading');
      perksTrigger.setAttribute('aria-busy', 'true');
      document.querySelector('.aph_collapse_bar_clickable')?.click();
      openPerksWhenReady();
    };

    wishlistTrigger.addEventListener('click', () => {
      if (!connectWishlist()) return;
      document.querySelector("joy-wishlist-icon[variant='floating']")?.shadowRoot?.querySelector('button')?.click();
    });

    perksTrigger.addEventListener('click', openPerks);
    perksBackdrop.addEventListener('click', () => closePerks());
    perksReturnClose.addEventListener('click', () => closePerks());
    perksCopy.addEventListener('click', async () => {
      const code = readRememberedPromoCode();
      if (!code) return;

      try {
        await navigator.clipboard.writeText(code);
        perksCopyLabel.textContent = perksCopy.dataset.pdPerksCopied;
        window.setTimeout(() => {
          perksCopyLabel.textContent = perksCopy.getAttribute('aria-label');
        }, 1600);
      } catch (error) {
        perksCopyLabel.textContent = perksCopy.getAttribute('aria-label');
      }
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('.aph_collapse_arrow [aria-label="Collapse"]')) closePerks(false);
      if (event.target.closest('.aph_collapse_fields > .aph_collapse_btn')) {
        window.setTimeout(syncAttracValidation, 0);
      }
    });

    document.addEventListener('input', (event) => {
      if (event.target.matches('.aph_collapse_first_name, .aph_collapse_email')) syncAttracValidation();
    });

    document.addEventListener('keydown', (event) => {
      if (!root.classList.contains('pd-perks-open')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closePerks();
        return;
      }

      if (event.key !== 'Tab') return;

      const activeDialog = root.classList.contains('pd-perks-returning') ? perksReturn : attracDialog;
      if (!activeDialog) return;

      const focusable = Array.from(
        activeDialog.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])')
      ).filter((element) => !element.disabled && element.getAttribute('aria-hidden') !== 'true');

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    const appObserver = new MutationObserver(() => {
      const hasWishlist = dock.classList.contains('is-wishlist-ready') || connectWishlist();
      const hasPerks = attracDialogIsReady() || prepareAttracDialog();

      if (!hasPerks && root.classList.contains('pd-perks-open') && !root.classList.contains('pd-perks-returning')) {
        const savedCode = readRememberedPromoCode();
        if (!revealRememberedPromo(savedCode)) {
          if (attracSuccessSeen) revealPerksRecovery();
          else closePerks(false);
        }
      }
      if (!hasWishlist) dock.classList.remove('is-wishlist-ready');
    });

    connectWishlist();
    prepareAttracDialog();
    appObserver.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
